import React from "react";
import CustomFormatNumber from "components/CustomFormatNumber";
import { useFormattedMessage } from "hooks";

const messages = {
    soldShares: "sold_shares",
    reservedShares: "reserved_shares",
    availableShares: "available_shares",
    shareShortText: "pc",
};

const SplitOrderDetail = ({ soldShares, reservedShares, shares }) => {
    const { formatMessage } = useFormattedMessage();

    const availableShares = parseInt(shares) - (parseInt(soldShares) + parseInt(reservedShares));

    const soldSharesPercent = Number.parseFloat((soldShares * 100) / parseInt(shares)).toFixed(0);
    const reservedSharesPercent = Number.parseFloat((reservedShares * 100) / parseInt(shares)).toFixed(0);
    const availableSharesPercent = Number.parseFloat((availableShares * 100) / parseInt(shares)).toFixed(0);

    return (
        <div>
            <div className="flex justify-between mb-6">
                <label className="text-16 fw-500">{formatMessage(messages.soldShares)}</label>
                <div>
                    <label>({soldSharesPercent}%)</label>{" "}
                    <CustomFormatNumber
                        className="text-16 fw-600"
                        value={soldShares}
                        fixed="0"
                        symbol={formatMessage(messages.shareShortText)}
                    />
                    <div className="mt-1 split-progress-bar bg-primary" style={{ width: `${soldSharesPercent}%` }} />
                </div>
            </div>
            <div className="flex justify-between mb-6">
                <label className="text-16 fw-500">{formatMessage(messages.reservedShares)}</label>
                <div>
                    <label>({reservedSharesPercent}%)</label>{" "}
                    <CustomFormatNumber
                        className="text-16 fw-600"
                        value={reservedShares}
                        fixed="0"
                        symbol={formatMessage(messages.shareShortText)}
                    />
                    <div className="mt-1 split-progress-bar bg-primary-light" style={{ width: `${reservedSharesPercent}%` }} />
                </div>
            </div>
            <div className="flex justify-between mb-6">
                <label className="text-16 fw-500">{formatMessage(messages.availableShares)}</label>
                <div>
                    <label>({availableSharesPercent}%)</label>{" "}
                    <CustomFormatNumber
                        className="text-16 fw-600"
                        value={availableShares}
                        fixed="0"
                        symbol={formatMessage(messages.shareShortText)}
                    />
                    <div className="mt-1 split-progress-bar bg-another-grey " style={{ width: `${availableSharesPercent}%` }} />
                </div>
            </div>
        </div>
    );
};

export default SplitOrderDetail;
